import { Callout } from '@/hub-shared'
import confirmVinculateImage from '@assets/img/svg/reading-side.svg'
import { useTranslation } from 'react-i18next'

import './confirm-vinculate.component.scoped.scss'

interface Props {
  urlCreators: string
  width: number
  height: number
}

export default ({ urlCreators, width, height }: Props) => {
  const { t } = useTranslation('modalVinculateSocialNetwork')

  return (
    <a
      href={`${urlCreators}/en/como-conectar-o-meu-instagram-a-squid?highlight=Como%20conectar%20o%20meu%20Instagram%20a%20Squid%3F`}
      style={{ textDecoration: 'none' }}
      target="_blank"
    >
      <div
        className="confirm-vinculate"
        style={{
          height: width < 991 ? `calc(${height}px - 69px - 21px - 2rem)` : null,
        }}
      >
        <div className="main-image-confirm-vinculate">
          <img src={confirmVinculateImage} alt="confirm-vinculate" />
        </div>
        <div className="description-confirm-vinculate">
          <p className="text-confirm-vinculate" dangerouslySetInnerHTML={{ __html: t('confirmVinculate') }} />
        </div>
        <Callout icon={'fa-regular fa-circle-play'} colorIcon="var(--primary_color)" style={{ width: '100%', margin: 0, flexShrink: 0 }}>
          <div className="display-flex-column">
            <h5 style={{ margin: 0 }} dangerouslySetInnerHTML={{ __html: t('confirmVinculateQuestion') }} />
            <span dangerouslySetInnerHTML={{ __html: t('toWhatch') }} />
          </div>
        </Callout>
      </div>
    </a>
  )
}
